export default {
  title: 'Info speichern',
  form: {
    remember_me: {
      label: 'Speichere meine Informationen für einen schnelleren Checkout',
    },
  },
};
